import { FilledButton } from 'components/Custom/FilledButton'
import { Box, CardMedia, Card } from 'components/Material/index'
import { SidebarFooter } from 'components/Custom/SidebarFooter'
import { useIsMobile } from 'hooks/useIsResponsive'
import { TopAppBar } from 'components/Custom/TopAppBar'
import { getMimeTypeFromExtension } from 'utils/utils'
import { useNavigate } from 'react-router-dom'
import { MdSaveAlt } from 'react-icons/md'
import useContratoInfoStore from 'store/useContrato'
import { CustomPdfViewer } from '../CustomPdfViewer'
import { FileExtension } from 'utils/fileFunction'

export const DocumentViewerFormalizationBody = () => {
  const isMobile = useIsMobile()
  const navigate = useNavigate()

  const { title, file, fileType } = useContratoInfoStore((state) => state.downloadInfo)
  const { id_documento } = useContratoInfoStore((state) => state.processedProposal)

  const downloadBase64File = (
    base64Content: string,
    fileExtension: FileExtension,
    fileName: string
  ) => {
    const fileType = getMimeTypeFromExtension(fileExtension)

    const byteCharacters = atob(base64Content)
    const byteArrays: Uint8Array[] = []
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }
    const blob = new Blob(byteArrays, { type: fileType })

    const url = window.URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = url
    a.download = fileName

    document.body.appendChild(a)
    a.click()

    window.URL.revokeObjectURL(url)
  }

  function imprimirDocumentoBase64(base64String: string) {
    // Decodifica a string base64
    const decodedData = atob(base64String)

    // Converte os dados decodificados em um array de bytes
    const byteArray = new Uint8Array(decodedData.length)
    for (let i = 0; i < decodedData.length; i++) {
      byteArray[i] = decodedData.charCodeAt(i)
    }

    const blob = new Blob([byteArray], { type: 'application/pdf' })

    const url = URL.createObjectURL(blob)

    const janelaDeImpressao = window.open(url)

    if (janelaDeImpressao) {
      janelaDeImpressao.onload = function () {
        janelaDeImpressao.print()
        URL.revokeObjectURL(url)
      }
    }
  }

  const renderImage = (base64Data: string, type: string) => {
    return (
      <Card sx={{ height: isMobile ? '55vh' : '65vh' }}>
        <CardMedia
          className="object-contain"
          component="img"
          image={`data:image/${type};base64,${base64Data}`}
          alt=""
          sx={{ height: isMobile ? '55vh' : '65vh' }}
        />
      </Card>
    )
  }

  const renderDefaultIcon = () => {
    return (
      <Box className="mt-[30vh] flex w-full justify-center">
        <MdSaveAlt className={`text-[150px] ${isMobile ? 'text-blue-bb' : 'text-white'}`} />
      </Box>
    )
  }

  return (
    <Box className="w-full h-full flex flex-col">
      <TopAppBar
        typographyLeftPadding={isMobile ? '20px' : '50px'}
        leftText={title}
        themeColor="white"
        rightIcon="close"
        onRightIconClick={() => navigate(-1)}
        className="border-b border-[rgba(0, 0, 0, 0.12)]"
      />

      <Box className="flex flex-col w-full justify-between flex-grow overflow-hidden relative">
        <Box className="w-full flex-grow overflow-auto">
          <Box className="flex flex-col justify-center items-center gap-5 p-5 w-full min-h-full">
            <Box className="w-full flex-grow flex justify-center items-center">
              {fileType === 'pdf' && <CustomPdfViewer file={file || ''} />}
              {(fileType === 'png' || fileType === 'jpg') && renderImage(file || '', fileType)}
              {fileType !== 'pdf' &&
                fileType !== 'png' &&
                fileType !== 'jpg' &&
                renderDefaultIcon()}
            </Box>
          </Box>
        </Box>
        <SidebarFooter>
          <Box className="flex flex-col items-center lg:flex-row w-full lg:justify-center gap-5 p-4">
            <FilledButton onClick={() => imprimirDocumentoBase64(file || '')} className="w-fit">
              Imprimir
            </FilledButton>
            <FilledButton
              form="primary"
              className="w-fit"
              onClick={() =>
                downloadBase64File(
                  file || '',
                  fileType as FileExtension,
                  `${title}_${id_documento}.${fileType}`
                )
              }
              disabled={!file}
            >
              Download
            </FilledButton>
          </Box>
        </SidebarFooter>
      </Box>
    </Box>
  )
}
